import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import CartState from "./context/CartState";
import ProductsContextProvider from "./context/ProductsContext";
ReactDOM.render(
  //   <React.StrictMode>
  <BrowserRouter>
    <ProductsContextProvider>
      <CartState>
        <App />
      </CartState>
    </ProductsContextProvider>
  </BrowserRouter>,
  //   </React.StrictMode>,
  document.getElementById("root")
);
